/** Moved to `@sizzlenz/shared-frontend/ui`. Re-exported for existing import paths. */
export { BrowserNavigationProvider, useBrowserNavigation } from '@sizzlenz/shared-frontend/ui';
